import * as constants from './../constants';
const defaultState = {
    vehicles: [],
    singleFastTagDetails: {},
    fastTagRechargeStatus: {},
    walletBalance:0
}
export default function fastagReducer(state = defaultState, action) {
    switch (action.type) {
        case constants.GET_FASTAG_VEHICLES_DATA:
            return { ...state, ...{ vehicles: action.payload } };
        case constants.GET_SINGLE_FASTTAG_DETAILS:
            return { ...state, ...{ singleFastTagDetails: action.payload } };
        case constants.GET_FASTTAG_RECHARGE_STATUS:
            return { ...state, ...{ fastTagRechargeStatus: action.payload } }
        case constants.GET_WALLET_BALANCE:
            return { ...state, ...{ walletBalance: action.payload } }
        default:
            return state;
    }
}
